<template>
  <v-container class="pa-0">
    <template
      v-if="mode == 'edit' && isAdmin"
    >
      <v-checkbox
        v-model="data.isDeveloper"
        hide-details
        class="mb-2"
      >
        <template v-slot:label>
          Utvecklaråkeri
        </template>
      </v-checkbox>
      <div class="developer-text text-caption mb-6">
        Ett utvecklaråkeris jobb är endast synliga för utvecklarchaufförer
      </div>
    </template>
    <v-text-field
      type="text"
      label="Företagsnamn*"
      outlined
      v-model="data.name"
      :rules="[formRules.required]"
      validate-on-blur
      required
      maxlength="40"
    ></v-text-field>
    <!--organizationNumber is not editable--->
    <template
      v-if="mode == 'signup'"
    >
      <v-text-field
        type="text"
        label="Organisationsnummer*"
        placeholder="NNNNNN-NNNN"
        outlined
        v-model="data.organizationNumber"
        :rules="[formRules.required,formRules.organizationNumber]"
        validate-on-blur
        required
        maxlength="11"
      ></v-text-field>
    </template>
    <template
      v-else
    >
      <v-text-field
        type="text"
        label="Organisationsnummer*"
        outlined
        v-model="data.organizationNumber"
        readonly
        @click="onNonEditable('För att ändra ert organisationsnummer, behöver ni kontakta oss')"
      ></v-text-field>
    </template>
    <v-text-field
      type="text"
      label="Telefonnummer*"
      outlined
      v-model="data.phone"
      :rules="[formRules.required]"
      validate-on-blur
      required
      maxlength="20"
    ></v-text-field>
    <v-text-field
      type="email"
      label="E-postadress*"
      outlined
      v-model="data.email"
      :rules="[formRules.required,formRules.email]"
      validate-on-blur
      required
      maxlength="50"
    ></v-text-field>
    <div class="text-h6 mb-4">Fakturaadress</div>
    <v-text-field
      type="text"
      label="Företagsnamn på faktura*"
      outlined
      v-model="data.invoiceName"
      :rules="[formRules.required]"
      validate-on-blur
      required
      maxlength="40"
    ></v-text-field>
    <v-text-field
      type="text"
      label="Postadress*"
      outlined
      v-model="data.address"
      :rules="[formRules.required]"
      validate-on-blur
      required
      maxlength="40"
    ></v-text-field>
    <v-text-field
      type="text"
      label="Adressrad 2"
      outlined
      v-model="data.address2"
      maxlength="40"
    ></v-text-field>
    <v-text-field
      type="text"
      label="Postnummer*"
      outlined
      v-model="data.zip"
      :rules="[formRules.required]"
      validate-on-blur
      required
      maxlength="6"
    ></v-text-field>
    <v-text-field
      type="text"
      label="Postort*"
      outlined
      v-model="data.city"
      :rules="[formRules.required]"
      validate-on-blur
      required
      maxlength="40"
    ></v-text-field>
  </v-container>
</template>

<script>
import { generalMixin } from '../mixins/general'
import { mapGetters } from 'vuex'

export default {
  props: {
    data: {
      type: Object,
      required: true
    },
    mode: {
      type: String,
      required: true
    }
  },
  mixins: [generalMixin],
  computed: {
    ...mapGetters(['isAdmin']),
  },
  methods: {
    onNonEditable(comment) {
      alert(comment)
    }
  }
}
</script>

<style>

</style>